import React, { useState } from "react";
import styles from "./ForgotPassword.module.css";
import ForgotPasswordSMS from "./ForgotPasswordSMS";

const ForgotPasswordNotification = ({ SMS, email }) => {
  const [showSMS, setShowSMS] = useState(false);

  if (showSMS) {
    return <ForgotPasswordSMS email={email} />;
  }

  return (
    <div className={styles.successContainer}>
      <p className={styles.formTitle}>Forgot Password</p>
      {SMS ? (
        <div className={styles.infoContainer}>
        <p className={styles.successMessage}>
        Success! Please check your messages.
      </p>
          <strong>Didn't receive the link</strong>
          <p className={styles.lightText}>
            Please send an email to{" "}
            <a href="mailto:support@treowellness.com">
              support@treowellness.com
            </a>
          </p>
        </div>
      ) : (
        <div className={styles.infoContainer}>
            <p className={styles.successMessage}>
              Success! Please check your email.
            </p>
          <p>
            <strong className={styles.mr5}>
              Didn't receive the email?
            </strong>
            <span
              onClick={() => setShowSMS(true)}
              className={styles.smsLink}
            >
              Click here to send SMS/Text reset code
            </span>
          </p>
          <p className={styles.paddingBottom}>
            <strong className={styles.mr5}>Need help?</strong>
            <a href="mailto:support@treowellness.com">
              support@treowellness.com
            </a>
          </p>
        </div>
      )}
    </div>
  );
};

export default ForgotPasswordNotification;
